import { ExternalAppId } from "../../generated/enums";
import { defineDirective } from "../../utils/angular";
import { AppSession } from "../appSession";

/** @internal */
export class ConnectOAuthCtrl {

    static create(): ng.IDirective {
        return defineDirective(ConnectOAuthCtrl, "shared/apps/connect/oauth.html", {
            "session": "="
        });
    }

    private session: AppSession
    ready: boolean

    $onInit() {
        this.session.establishNewConnection().then(r => this.ready = true);
    }

    get app() {
        return this.session?.app
    }

    get claas() {
        const { app } = this
        return app?.appId == ExternalAppId.Claas
    }

    onConnectClick() {
        this.session.onEstablishNewConnection();
    }

}
